"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let PaymentsView = class PaymentsView extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    getItems(...args) {
        if (this.parameters) {
            return this.$fn.fetch('list_payment', { parameters: this.parameters });
        }
        const parameters = this.params;
        return parameters && parameters.account && parameters.date_from
            ? this.$fn.fetch('list_payment', { parameters })
            : [];
    }
    getInvoiceBadgeClass(...args) {
        const data = args[0];
        if (_.isEmpty(data)) {
            return;
        }
        const payment_balance = data.payment_balance || 0;
        const invoice_gross_amount = data.invoice_gross_amount;
        if (payment_balance == 0) {
            return 'bg-green-200';
        }
        if (payment_balance < 0) {
            return 'bg-yellow-200';
        }
        if (payment_balance < invoice_gross_amount) {
            return 'bg-blue-200';
        }
    }
    parameters;
    onParameters(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parameters");
    }
    selectedItems;
    params;
    totals;
    paymentMethods;
    async $$load_paymentMethods() {
        return this.$fn.fetch('list_payment_method')
            .then(data => _.reduce(data, (m, v, k) => _.set(m, v.id, this.$fn.pgettext('PaymentMethod', v.name))));
    }
    ux;
    b_2248226175642056_headerShowColumnSelectorButton;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    async $$load_b_2248226175642056_columns() {
        return [{
                field: "payment_method",
                name: this.$fn.pgettext("PaymentBrowserView", "Method"),
                formatter: {
                    name: "gettext",
                    context: "PaymentMethod",
                    conversion: ["Unsnake",
                        "Sentence",
                    ],
                    filterInput: true,
                },
            },
            {
                field: "transaction_number",
                name: this.$fn.pgettext("PaymentBrowserView", "Number"),
                type: "command",
                formatter: [{
                        name: "chain",
                        formatters: [{
                                name: "link",
                                href: "#",
                            },
                            {
                                name: "cellclass",
                                value: (row) => ({
                                    'font-weight-bold': true,
                                    'bg-yellow-200': !row.locked
                                }),
                            },
                        ],
                    },
                ],
            },
            {
                field: "transaction_type",
                name: this.$fn.pgettext("PaymentBrowserView", "Type"),
                formatter: {
                    name: "gettext",
                    context: "TransactionType",
                    conversion: "Unsnake",
                    filterInput: true,
                },
            },
            {
                field: "transaction_date",
                name: this.$fn.pgettext("PaymentBrowserView", "Date"),
                type: "date",
            },
            {
                field: "transaction_title",
                name: this.$fn.pgettext("PaymentBrowserView", "Title"),
            },
            {
                field: "description",
                name: this.$fn.pgettext("PaymentBrowserView", "Description"),
            },
            {
                field: "notes",
                name: this.$fn.pgettext("PaymentBrowserView", "Notes"),
            },
            {
                field: "opening_balance",
                name: this.$fn.pgettext("PaymentBrowserView", "Opening balance"),
                type: "number",
                formatter: "number",
                noFooterTotals: true,
            },
            {
                field: "amount_in",
                name: this.$fn.pgettext("PaymentBrowserView", "In"),
                type: "number",
                formatter: "number",
            },
            {
                field: "amount_out",
                name: this.$fn.pgettext("PaymentBrowserView", "Out"),
                type: "number",
                formatter: "number",
            },
            {
                field: "closing_balance",
                name: this.$fn.pgettext("PaymentBrowserView", "Closing balance"),
                type: "number",
                formatter: "number",
                noFooterTotals: true,
            },
            {
                field: "currency",
                name: this.$fn.pgettext("PaymentBrowserView", "Currency"),
            },
            {
                field: "exchange_rate",
                name: this.$fn.pgettext("PaymentBrowserView", "Exchange Rate"),
                type: "number",
                formatter: "number",
                noFooterTotals: true,
            },
            {
                field: "reference_number",
                name: this.$fn.pgettext("PaymentBrowserView", "Ref Nr."),
            },
            {
                field: "file_number",
                name: this.$fn.pgettext("PaymentBrowserView", "File Nr."),
            },
            {
                field: "company_name",
                name: this.$fn.pgettext("PaymentBrowserView", "Own company"),
                formatter: {
                    name: "routeLink",
                    to: "company",
                    navigateOnIconClick: true,
                    params: {
                        id: "company_id",
                    },
                },
            },
            {
                field: "client_name",
                name: this.$fn.pgettext("PaymentBrowserView", "Client"),
                formatter: {
                    name: "routeLink",
                    to: "company",
                    navigateOnIconClick: true,
                    params: {
                        id: "client_id",
                    },
                },
            },
            {
                field: "invoices",
                name: this.$fn.pgettext("PaymentBrowserView", "Invoices"),
                formatter: [{
                        name: "chain",
                        mode: "mapReduce",
                        separator: ", ",
                        formatterContext: "value",
                        formatters: [{
                                name: "getvalue",
                                opts: {
                                    field: "invoice_number",
                                    source: "value",
                                },
                            },
                            {
                                name: "routeLink",
                                to: "invoice",
                                navigateOnIconClick: true,
                                params: {
                                    id: "id",
                                },
                            },
                            {
                                name: "badge",
                                badgeClass: this.getInvoiceBadgeClass,
                            },
                        ],
                    },
                ],
            },
        ];
    }
    dataMembers = ['selectedItems', 'params', 'totals', 'paymentMethods', 'ux', 'b_2248226175642056_headerShowColumnSelectorButton', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                params: {},
                totals: [{
                        id: 0,
                        amount_in: 0,
                        amount_out: 0,
                    },
                ],
                paymentMethods: null,
                ux: null,
                b_2248226175642056_headerShowColumnSelectorButton: false,
                b_2248226175642056_columnDefaults: {
                    sortable: false,
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_7984_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_showModal_7986_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                modal: true,
                oid: $event.data.data.id,
            },
        };
    }
    async evh_2248226175642056_command_7985_getWhen($event) {
        return $event.data.column.id === 'transaction_number';
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_7982 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_7981 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_7982,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_7981],
        });
        const act_2248226175642056_setData_7984 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_7984_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_7983 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_7984,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_7983],
        });
        const act_2248226175642056_showModal_7986 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_7986_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_7985 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_7986,
            event: "command",
            when: this.evh_2248226175642056_command_7985_getWhen,
            displayName: "showModal",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_7985],
        });
        return {
            act_7315092382398562_reloadComponentData_7982,
            evh_7315092382398562_reload_7981,
            evh_7315092382398562_reload,
            act_2248226175642056_setData_7984,
            evh_2248226175642056_selectedRowsChanged_7983,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_showModal_7986,
            evh_2248226175642056_command_7985,
            evh_2248226175642056_command,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], PaymentsView.prototype, "parameters", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parameters'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], PaymentsView.prototype, "onParameters", null);
PaymentsView = __decorate([
    (0, vue_property_decorator_1.Component)()
], PaymentsView);
exports.default = PaymentsView;
vue_property_decorator_1.Vue.component("PaymentsView", PaymentsView);
